module.exports = __webpack_public_path__ + "static/media/chatbot_i.10aa0be5.jpg";